// breadcrumbs

function handleBreadcrumbClick(gridCat) {
  // console.log('handleBreadcrumbClick', gridCat)
  // Reset all breadcrumb aria-expanded states first
  const breadcrumbButtons = document.querySelectorAll('.breadcrumb[data-grid-cat]')
  breadcrumbButtons.forEach((button) => button.setAttribute('aria-expanded', 'false'))

  const menu = document.querySelector('.mobile-nav-grid.accordion-nav')
  if (!menu) return console.error('handleBreadcrumbClick - No menu found')

  // get menu item or category that matches selected breadcrumb category (gridCat)
  const menuItem = menu.querySelector(`button[data-handle="${gridCat}"]`)
    ? menu.querySelector(`button[data-handle="${gridCat}"]`)
    : menu.querySelector(`.mobile-nav-grid .accordion-nav__panel a[data-handle="${gridCat}"]`)
  if (!menuItem)
    return console.error('handleBreadcrumbClick - No menu item found for gridCat:', gridCat)

  // get menuItem's corresponding tabs and panels. fyi - menu tabs open menu panels.
  const menuItemIsTab = menuItem.classList.contains('accordion-nav__tab') // check if menuItem or category tab
  const menuPanel = menuItemIsTab
    ? menuItem.nextElementSibling
    : menuItem.closest('.accordion-nav__panel')
  const menuTab = menuItemIsTab ? menuItem : menuPanel?.previousElementSibling
  const isSubNav = menuItem.closest('.accordion-sub-nav')
  const parentPanel = menuTab?.closest('.accordion-nav__panel')
    ? menuTab.closest('.accordion-nav__panel')
    : menu
  const parentTab = menuTab?.closest('.accordion-nav__panel')
    ? parentPanel?.previousElementSibling
    : null
  const scrollContainer = isSubNav ? parentPanel : document.querySelector('.mobile-nav__main')

  // close other active menus
  if (!menuItemIsTab) {
    const currentlyActiveMenus = parentPanel?.querySelectorAll(
      `.mobile-nav-grid button.active[data-handle]`,
    )
    currentlyActiveMenus?.forEach((currentlyActive) => {
      const currentlyActiveSubNav = currentlyActive.closest('.accordion-sub-nav')
      // don't close featured menu
      if (
        currentlyActive.classList.contains('featured') &&
        currentlyActive.classList.contains('active') &&
        !currentlyActiveSubNav
      ) {
      } else {
        currentlyActive.click()
      }
    })
  }

  // open menu if not already open
  const isActive =
    menuTab?.classList.contains('active') ||
    menuTab?.classList.contains('accordion-nav__tab--active')
  if (!isActive) {
    menuTab.click()
  }

  // open parent menu if applicable
  if (isSubNav) {
    if (parentTab && !parentTab.classList.contains('active')) {
      parentTab.click()
    }
  }

  // scroll to menuItem and open menu
  setTimeout(() => {
    if (!scrollContainer) return
    const menuItemHeight = menuItem.getBoundingClientRect().top
    const containerScrollTop = scrollContainer.scrollTop
    const scrollOffset = isSubNav ? 50 : 86 // mobile header height + category tab height
    const scrollValue = parseInt(containerScrollTop + menuItemHeight - scrollOffset)

    scrollContainer.scrollTo({
      top: scrollValue,
      behavior: 'instant',
    })

    const hamburger = document.querySelector('#primary-nav-toggle')
    if (!hamburger) return
    hamburger.click()
  }, 250)
}

// Breadcrumb listeners for menu
function initBreadcrumbClickListener() {
  // console.log('initBreadcrumbClickListener')
  const breadcrumbLinksPDP = document.querySelectorAll(
    '.liquid-pdp__breadcrumbs .crumb-category[data-grid-cat]',
  )
  const breadcrumbNavigationLink = document.querySelector(
    '.liquid-pdp__breadcrumbs[data-mobile-nav]',
  )

  if (!breadcrumbLinksPDP && !breadcrumbNavigationLink) return

  const breadcrumbLinks = [...breadcrumbLinksPDP]

  // console.log('breadcrumbLinks', breadcrumbLinks)

  breadcrumbLinks.forEach((link) => {
    link.addEventListener('click', (event) => {
      event.preventDefault()

      const gridCat = link.dataset.gridCat
      if (!gridCat) return

      // Set aria-expanded to true when opening menu
      link.setAttribute('aria-expanded', 'true')

      handleBreadcrumbClick(gridCat)
    })
  })

  if (breadcrumbNavigationLink) {
    breadcrumbNavigationLink.addEventListener('click', (event) => {
      event.preventDefault()
      // console.log('breadcrumbNavigationLink clicked')
      const mobileNav = breadcrumbNavigationLink.dataset.mobileNav
      if (!mobileNav) return

      const typeSelectorInput = document.querySelector(`input[value="${mobileNav}"]`)
      // console.log('typeSelectorInput', typeSelectorInput)
      if (typeSelectorInput) {
        // console.log('typeSelectorInput clicked')
        typeSelectorInput.click()
      } else {
        console.error('Type selector input not found for', mobileNav)
      }

      const hamburger = document.querySelector('#primary-nav-toggle')
      // console.log('hamburger', hamburger)
      if (!hamburger) return
      //  console.log('hamburger clicked')
      hamburger.click()
    })
  }
}

document.addEventListener('DOMContentLoaded', () => initBreadcrumbClickListener())
